import React, { Component } from 'react';
import {
    Container,
    withStyles,
    Grid,
    Card,
    CardActionArea,
    CardContent,
    CardMedia,
    Typography
} from '@material-ui/core';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { REQUEST_ALERTS,  REQUEST_TAGS } from '../core/handlers.actions';
import { Link } from 'react-router-dom';

const styles = (theme: any) => ({
    container: {
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(6)
    },
    cardRoot: {
        maxWidth: 345
    },
    media: {
        height: 140
    }
});

interface Props {
    classes: any;
    getTags: () => void;
    getAlerts: () => void;
}

interface State {
    addWallOpen: boolean;
    editItemId: string | null;
}

class Dashboard extends Component<Props, State> {
    state: State = {
        addWallOpen: false,
        editItemId: null
    }
    constructor(props: Props) {
        super(props);
        this.addWallModalOpenHandler = this.addWallModalOpenHandler.bind(this);
        this.editItem = this.editItem.bind(this);
    }
    componentDidMount() {
        const { getTags, getAlerts } = this.props;
        getTags();
        getAlerts();
    }

    public editItem(id: string) {
        this.setState({ ...this.state, editItemId: id, addWallOpen: !this.state.addWallOpen });
    }
    public addWallModalOpenHandler() {
        this.setState({ ...this.state, addWallOpen: !this.state.addWallOpen, editItemId: null });
    }

    public render() {
        const { classes } = this.props;
        return (
            <Container maxWidth="lg" className={classes.container}>
                
                <Grid container spacing={3}>                    
                    <Grid item xs={6} sm={6} md={3} >
                        <Card className={classes.cardRoot} >
                            <Link to={'/walls'} className='a-no-underline'>
                                <CardActionArea>
                                    <CardMedia className={classes.media} image='https://pancan.org/wp-content/uploads/2020/10/honor-wall-animated-thumb.gif' />
                                    <CardContent className='primary-card'>
                                        <Typography gutterBottom variant='h5' component='h2'>Honor Walls</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Link>
                        </Card>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3}>
                        <Card className={classes.cardRoot} >
                            <Link to={'/events'} className='a-no-underline'>
                                <CardActionArea>
                                    <CardMedia className={classes.media} image='https://pancan.org/wp-content/uploads/2020/12/PS-San-Antonio-11-7-20_733x450.jpg' />
                                    <CardContent className='primary-card'>
                                        <Typography gutterBottom variant='h5' component='h2'>Educational Events</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Link>
                        </Card>
                    </Grid>
                    {/* <Grid item xs={6} sm={6} md={3}>
                        <Card className={classes.cardRoot} >
                            <Link to={'/walls'} className='a-no-underline'>
                                <CardActionArea>
                                    <CardMedia className={classes.media} image='https://pancan.org/wp-content/uploads/2018/01/Screen-Shot-2018-01-26-at-9.39.19-AM.png' />
                                    <CardContent className='primary-card'>
                                        <Typography gutterBottom variant='h5' component='h2'>Educational Events</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Link>
                        </Card>
                    </Grid>
                    
                    <Grid item xs={6} sm={6} md={3} >
                        <Card className={classes.cardRoot} >
                            <Link to={'/walls'} className='a-no-underline'>
                                <CardActionArea>
                                    <CardMedia className={classes.media} image='https://pancan.org/wp-content/uploads/2022/12/CTAM-2023-Webinar-Header-1800x600-1.png' />
                                    <CardContent className='primary-card'>
                                        <Typography gutterBottom variant='h5' component='h2'>Webinar RSVPs</Typography>
                                    </CardContent>
                                </CardActionArea>
                            </Link>
                        </Card>
                    </Grid> */}
                </Grid>
            </Container>
        );
    }
}
const actions = (dispatch: Dispatch) => ({
    getTags: () => dispatch({ type: REQUEST_TAGS }),
    getAlerts: () => dispatch({ type: REQUEST_ALERTS })
});
export default connect(null, actions)(withStyles(styles)(Dashboard));